<script type="ts">
	import { onMount } from 'svelte';

	let closed = false;
	onMount(() => {
		closed = false;
	});
</script>

<div class="email grid__wide shadow-xl">
	<div class="notification">
		<div class="bubble">1</div>
		You've got mail!
	</div>
	<div class="email-container">
		<div class="header">
			<div class="avatar">JM</div>
			<div class="name"><span class="from">Jonas McApii</span></div>
			<div class="title">[Urgent] API Service Notice</div>
			<div class="meta">
				<div class="label">Inbox</div>
				<div class="date">Saturday, March 31, 2022</div>
			</div>
		</div>
		<div class="content" class:closed>
			<slot />
		</div>
	</div>
</div>

<style lang="scss">
	.email {
		background-color: var(--bgc-high);
		border-radius: $border_radius;
		font-size: 16px;
		font-family: var(--font-system);

		-webkit-font-smoothing: initial;
		color: var(--text-bold);

		/* // Need to make this responsive */
		max-width: 100%;
		overflow-x: hidden;
	}
	.email-container {
		padding: 40px;
	}

	.notification {
		/* max-width: 320px; */
		/* background-color: hsl(0 0% 98%); */
		background-image: var(--light-gray-gradient);
		background-color: hsl(0deg 0% 40% / 0.05);

		border: 1px solid var(--bgc-high);
		border-bottom: 1px solid var(--bgc-high);
		border-radius: 12px;
		padding: 14px 30px;
		margin-left: auto;
		margin-right: auto;

		display: flex;
		align-items: center;
		gap: 10px;

		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;

		color: var(--text-bold);
		font-weight: 500;
		letter-spacing: 0.2px;
	}

	.bubble {
		background-color: rgb(225, 60, 0);
		color: white;
		border-radius: 50%;
		width: 19px;
		height: 19px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 10px;
		font-weight: 700;
	}

	.closed {
		height: 7em;
		overflow: hidden;
	}

	.header {
		display: grid;
		grid-template-areas:
			'avatar name meta'
			'avatar title meta';
		grid-template-columns: 54px 5fr 2fr;
		grid-template-rows: 22px auto;
		align-items: center;

		font-size: 0.8rem;
		padding-bottom: 20px;
		border-bottom: 1px solid var(--color-separator);
	}

	.avatar {
		width: 43px;
		height: 43px;
		border-radius: 50%;
		background-color: royalblue;
		display: flex;
		justify-content: center;
		align-items: center;
		grid-area: avatar;
		color: white;
		font-weight: 600;
		letter-spacing: 0.05em;
	}

	.date {
		font-size: 0.8em;
		grid-area: date;
	}
	.title {
		grid-area: title;
	}

	.meta {
		grid-area: meta;
		align-self: start;
		text-align: right;
		min-width: 150px;
	}


	.from {
		font-weight: bold;
	}

	.label {
		font-size: 0.8em;
		background-color: var(--bgc-accent);
		color: var(--text-accent);
		padding: 0.1em 0.75em;
		border-radius: 5px;
		text-align: center;
		display: inline-block;
		margin-bottom: 10px;
	}

	.content {
		padding: 20px;
	}

	:global(.email .content p) {
		margin-top: 15px;
		margin-bottom: 15px;
	}


	@include phone() {
		.title {
			font-weight: bold;
		}
		.from {
			font-weight: 400;
		}
		.meta {
			display: flex;
			flex-direction: column-reverse;
			text-align: center;
			align-items: center;
			justify-content: center;
			margin-left: auto;
			margin-right: auto;
			gap: 4px;
			min-width: 100px;
		}
		.header {
			display: flex;
			flex-direction: column;
			gap: 2px;
		}
		.email-container {
			padding: 10px;
		}
	}
</style>
